import actions from "./actions";

const initState = {
  health: null,
  types: null,
  areas: null,
  schools: null,
  loading: false,
  tickect_type: null,
  tickect_area: null,
};

export default function userReducer(state = initState, action) {
  switch (action.type) {
    case actions.FETCH_HEALTH:
    case actions.FETCH_HEALTH_SEARCH:
    case actions.HEALTH_TOGGLE:
      return {
        ...state,
        loading: true,
      };

    case actions.FETCH_HEALTH_SUCCESS:
      return {
        ...state,
        health: action.data,
        loading: false,
      };

    case actions.FETCH_CATEGORY_SUCCESS:
      return {
        ...state,
        types: action.types,
        areas: action.areas,
      };

    case actions.TYPE_AREA_SUCCESS:
      return {
        ...state,
        tickect_type: action.types,
        tickect_area: action.areas,
      };

    case actions.FETCH_SCHOOL_SUCCESS:
      return {
        ...state,
        schools: action.schools,
      };

    case actions.HEALTH_TOGGLE_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case actions.SET_LOADING:
      return {
        ...state,
        loading: action.loading,
      };

    default:
      return state;
  }
}
